import { arrayFormEdit } from "../../actions/schemaActions";

const onArrayFormEdit = (property, newValue, index, component) => {
  component.props.dispatch(
    arrayFormEdit(component.props.id, property, index, newValue)
  );
};

export default onArrayFormEdit;
